import { Component, inject } from '@angular/core';
import { MatBottomSheet } from '@angular/material/bottom-sheet';
import { MatButtonModule } from '@angular/material/button';
import { MatDialog } from '@angular/material/dialog';
import { MatIconModule } from '@angular/material/icon';
import { RouterOutlet } from '@angular/router';
import { BottomNavigationComponent } from '@components/bottom-navigation/bottom-navigation.component';
import { SupportBottomSheetComponent } from '@components/bottom-sheets/support-bottom-sheet/support-bottom-sheet.component';
import {
  AccessabilityDialogComponent,
  AccessabilityDialogData,
} from '@components/dialogs/accessability-dialog/accessability-dialog.component';
import { SupportDialogComponent } from '@components/dialogs/support-dialog/support-dialog.component';
import { FooterComponent } from '@components/footer/footer.component';
import { HeaderComponent } from '@components/header/header.component';
import { GeneralService } from '@shared/services/general.service';
import { TokenService } from '@shared/services/token.service';

@Component({
  selector: 'layout-main',
  imports: [
    RouterOutlet,
    HeaderComponent,
    FooterComponent,
    BottomNavigationComponent,
    MatButtonModule,
    MatIconModule,
  ],
  templateUrl: './layout-main.component.html',
  styleUrls: ['./layout-main.component.scss'],
})
export class LayoutMainComponent {
  generalService = inject(GeneralService);
  private readonly bottomSheet = inject(MatBottomSheet);
  private readonly dialog = inject(MatDialog);
  private readonly tokenService = inject(TokenService);

  openSupport() {
    if (!this.tokenService.getRtk()) {
      const data: AccessabilityDialogData = {
        message: 'لطفا جهت ارسال پیام به پشتیبانی، به حساب کاربری خود ورود کنید',
      };
      this.dialog.open(AccessabilityDialogComponent, {
        data,
      });
      return;
    }
    if (this.generalService.isSmallScreen()) {
      this.bottomSheet.open(SupportBottomSheetComponent, {
        panelClass: 'support-bottom-sheet',
      });
    } else {
      this.dialog.open(SupportDialogComponent);
    }
  }
}
